import autoTable from "jspdf-autotable";
import { printSRFSConfigData, printSRFSConfiguration } from "./SRFSConstant";
import {
  customFontFamily,
  dynamicHeader,
  footerConfig,
  headerConfig,
  tableConfigurationheaderandfooter,
} from "./srfsConfig";


const certificateHeader = "/images/quotheader.png";
const certificateFooter = "/images/certificate_footer.png";


export const drawLetterHeadHeaderImg = () => {
  let headerImage = certificateHeader;
  try {
    if (printSRFSConfigData.letterHeadAndElectronicAndDraftConfig?.letterHead) {
      const scaledWidth = printSRFSConfiguration.pageWidth;
      const scaledHeight = headerConfig.lettterImgHeight;
      printSRFSConfiguration.pdfDoc.addImage(
        headerImage,
        "PNG",
        0,
        0,
        scaledWidth,
        scaledHeight
      );
    }
  } catch (error) {
    console.error("Error drawing header image:", error);
  }
};
export const drawLetterFooterImg = () => {
  try {
    if (printSRFSConfigData.letterHeadAndElectronicAndDraftConfig?.letterHead && footerConfig?.footerimgRemove) {
      const scaledWidth = printSRFSConfiguration.pageWidth;
      // Draw the image on the page
      printSRFSConfiguration.pdfDoc.addImage(
        certificateFooter,
        "PNG",
        0,
        printSRFSConfiguration.pageHeight - footerConfig.footerimgHeight + 2,
        scaledWidth,
        footerConfig.footerimgHeight
      );
    }
  } catch (error) {
    console.error("Error drawing footer image:", error);
  }
};

export const drawDynamicHeader = () => {
  let localY = headerConfig?.lettterImgHeight + 5;

  const panels = dynamicHeader(
    printSRFSConfigData.SRFSDetailsConfig
  );
  let tableRows = [];
  for (let i = 0; i < panels.leftPanel.keys.length; i++) {
    tableRows.push([
      {
        content: panels.leftPanel.keys[i],
        styles: { halign: "left", font: customFontFamily?.boldFont },
      },
      { content: panels.leftPanel.values[i], styles: { halign: "left" } },
      {
        content: panels.rightPanel.keys[i],
        styles: { halign: "left", font: customFontFamily?.boldFont },
      },
      { content: panels.rightPanel.values[i], styles: { halign: "left" } },
      {
        content: panels.lastPanel.keys[i],
        styles: { halign: "left", font: customFontFamily?.boldFont },
      },
      { content: panels.lastPanel.values[i], styles: { halign: "left" } },
    ]);
  }
  // Draw the table using autoTable
  autoTable(printSRFSConfiguration.pdfDoc, {
    startY: localY,
    margin: tableConfigurationheaderandfooter?.margins,
    body: tableRows,
    theme: "grid",
    headStyles: {
      fillColor: false,
      textColor: printSRFSConfiguration.textColor,
      fontSize: headerConfig.tableRowfontSizes,
      font: customFontFamily?.boldFont,
    },
    styles: {
      fillColor: false,
      textColor: printSRFSConfiguration.textColor,
      lineColor: printSRFSConfiguration.textColor,
      lineWidth: printSRFSConfiguration.lineWidth,
      fontSize: headerConfig.tableRowfontSizes,
      halign: "center",
      cellPadding: headerConfig.cellPadding,
      font: customFontFamily?.normalFont,
    },
  });
};

export const drawDynamicFooter = () => {
  // if(!printSRFSConfigData.IsCSRF) return;
  let srfsSetting =
    printSRFSConfigData.letterHeadAndElectronicAndDraftConfig;

  // let Row1 = ["Customer Representative Name", "Sign","BCL Representative Name","Sign"];
  // let Row2 = [
  //   // printSRFSConfigData.SRFSDetailsConfig.userId?.createdBy,
  //   "",
  //   "",
  //   printSRFSConfigData.SRFSDetailsConfig.userId?.approvedBy,
  //   ""
  // ];
  // let Row3 = [
  //   "",
  //   "",
  //   "",
  //   // printSRFSConfigData.SRFSDetailsConfig.userImg?.createdByImg,
  //   printSRFSConfigData.SRFSDetailsConfig.userImg?.approvedByImg,
  // ];

  // const tableRows = [];
  // // Add Row1 to tableRows
  // tableRows.push(
  //   Row1.map((content) => ({
  //     content,
  //     styles: {
  //       font: customFontFamily?.boldFont,
  //       fontStyle: customFontFamily?.bold,
  //       halign: "center",
  //     },
  //   }))
  // );

  // // Add Row2 to tableRows
  // tableRows.push(
  //   Row2.map((content) => ({
  //     content : srfsSetting?.electronicSign ? content : "",
  //     styles: {
  //       font: customFontFamily?.normalFont,
  //       halign: "center",
  //       minCellHeight: 25,
  //     },
  //   }))
  // );

  // Add Row3 with images (if present)
  // if (srfsSetting?.signImg) {
  //   tableRows.push(
  //     Row3.map((imgSrc) => ({
  //       content: "", // Content remains empty; images will be added later
  //       imgSrc, // Pass the image source for use in didDrawCell
  //       styles: {
  //         font: customFontFamily?.normalFont,
  //         halign: "center",
  //         minCellHeight: 25,
  //       },
  //     }))
  //   );
  // }

  // let formattedTableRows = tableRows.map((row, rowIndex) =>
  //   row.map((column, columnIndex) => ({
  //     ...column, // Keep all other properties of the column
  //     styles: {
  //       ...column.styles, // Preserve existing styles
  //       halign:
  //         columnIndex === 0 // First column
  //           ? "center"
  //           : columnIndex === row.length - 1 // Last column
  //           ? "center"
  //           : "center", // Default alignment for other cases
  //     },
  //   }))
  // );

  // Define table structure
  const tableRows = [
    // Row 1: Headers
    [
      {
        content: "Customer Representative Name",
        rowSpan: 2,
        styles: {
          font: customFontFamily?.boldFont,
          fontStyle: customFontFamily?.bold,
          halign: "center",
          valign: "middle",
        },
      },
      {
        content: "Sign",
        rowSpan: 2,
        styles: {
          font: customFontFamily?.boldFont,
          fontStyle: customFontFamily?.bold,
          halign: "center",
          valign: "middle",
        },
      },
      {
        content: "BCL Representative Name",
        colSpan: 2,
        styles: {
          font: customFontFamily?.boldFont,
          fontStyle: customFontFamily?.bold,
          halign: "center",
        },
      },
    ],
    // Row 2: Sub-headers for BCL columns
    [
      {
        content: "Prepared By",
        styles: {
          font: customFontFamily?.boldFont,
          fontStyle: customFontFamily?.bold,
          halign: "center",
        },
      },
      {
        content: "Approved By",
        styles: {
          font: customFontFamily?.boldFont,
          fontStyle: customFontFamily?.bold,
          halign: "center",
        },
      },
    ],
    // Row 3: Names
    [
      {
        content: srfsSetting?.electronicSign ? "" : "",
        styles: {
          font: customFontFamily?.normalFont,
          halign: "center",
          minCellHeight: srfsSetting?.signImg ? 30 : 25,
        },
      },
      {
        content: "",
        styles: {
          font: customFontFamily?.normalFont,
          halign: "center",
          minCellHeight: srfsSetting?.signImg ? 30 : 25,
        },
      },
      {
        content: srfsSetting?.electronicSign
          ? printSRFSConfigData.SRFSDetailsConfig.userId?.createdBy || ""
          : "",
        styles: {
          font: customFontFamily?.normalFont,
          halign: srfsSetting?.signImg ? "left" : "center",
          minCellHeight: srfsSetting?.signImg ? 30 : 25,
        },
      },
      {
        content: srfsSetting?.electronicSign
          ? printSRFSConfigData.SRFSDetailsConfig.userId?.approvedBy || ""
          : "",
        styles: {
          font: customFontFamily?.normalFont,
          halign: srfsSetting?.signImg ? "left" : "center",
          minCellHeight: srfsSetting?.signImg ? 30 : 25,
        },
      },
    ],
  ];

  // Store image data for later rendering
  const imageRow = [
    "",
    "",
    printSRFSConfigData.SRFSDetailsConfig.userImg?.createdByImg,
    printSRFSConfigData.SRFSDetailsConfig.userImg?.approvedByImg,
  ];
   // Calculate the total available width of the table
      const totalPageWidth =
      printSRFSConfiguration.pageWidth -
      tableConfigurationheaderandfooter?.margins.right * 2;
      const columnPercentages = [26, 20, 27, 27];
      // Calculate the actual column widths based on percentages
      const columnWidths = columnPercentages.map((percentage) => {
        return (totalPageWidth * percentage) / 100;
      });

  // Generate table with autoTable
  autoTable(printSRFSConfiguration.pdfDoc, {
    startY:
      printSRFSConfiguration.pageHeight - footerConfig.footerimgHeight - footerConfig.footerandbodygap - 50,
    margin: tableConfigurationheaderandfooter?.margins,
    body: tableRows,
    theme: "grid",
    styles: {
      fillColor: false,
      textColor: printSRFSConfiguration.textColor,
      lineColor: printSRFSConfiguration.textColor,
      lineWidth: printSRFSConfiguration.lineWidth,
      fontSize: printSRFSConfiguration.fontSizes.h2,
      halign: "center",
      valign: "middle",
      font: customFontFamily?.normalFont,
      cellPadding: { top: 5, left: 5, bottom: 5, right: 5 },
    },
    columnStyles: {
      // Set equal width for each column
      0: { cellWidth: columnWidths[0] },
      1: { cellWidth: columnWidths[1] },
      2: { cellWidth: columnWidths[2] },
      3: { cellWidth: columnWidths[3] },
    },
    didDrawCell: (data) => {
      const { section, row, column, cell } = data;
      
      // Draw images in the last row (row index 2)
      if (section === "body" && row.index === 2 && srfsSetting?.signImg) {
        const imgSrc = imageRow[column.index];
        if (imgSrc) {
            const imgWidth = 60;
            const imgHeight = cell.height - 10;
            const x = cell.x + (cell.width - imgWidth) / 2;
            const y = cell.y + 5;
            // Add the image to the PDF
            printSRFSConfiguration.pdfDoc.addImage(
              imgSrc,
              "PNG",
              x,
              y,
              imgWidth,
              imgHeight
            );
        }
      }
    },
  });
};
